function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class2, _class3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Component, register, bind, emitEvent } from 'ovee.js';
import gsap from 'gsap';

var _class = (_dec = register('floor-plan'), _dec2 = bind('click', '[data-floor]'), _dec3 = bind('click', '[data-room]'), _dec(_class2 = (_class3 = /*#__PURE__*/function (_Component) {
  _inherits(_class3, _Component);

  var _super = _createSuper(_class3);

  function _class3() {
    _classCallCheck(this, _class3);

    return _super.apply(this, arguments);
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      this.floors = this.$element.querySelectorAll('[data-floor]');
      this.roomLists = this.$element.querySelectorAll('[data-room-list]');
      this.rooms = this.$element.querySelectorAll('[data-room]');
      this.contents = this.$element.querySelectorAll('[data-content]');
      this.preview = this.$element.querySelector('[data-preview]');
      this.summary = this.$element.querySelector('[data-summary]');
      this.dropdown = this.$element.querySelector('[dropdown-trigger]');
      this.isAnimating = false;
      this.calcHeights();
      this.setInitial();
      this.bind();
    }
  }, {
    key: "floorSwitch",
    value: function floorSwitch(e) {
      var _this = this;

      var target = e.target;
      if (this.isAnimating || target.classList.contains('is-active')) return;
      this.isAnimating = true;
      var targetListID = target.dataset.listId;
      var targetData = JSON.parse(target.dataset.floorData);
      this.floors.forEach(function (floor) {
        floor.classList.remove('is-active');
        floor.setAttribute('aria-expanded', false);
      });
      target.classList.add('is-active');
      target.setAttribute('aria-expanded', true);
      this.dropdown.querySelector('span').textContent = e.target.textContent;
      emitEvent(this.dropdown, 'close');
      var firstRoom = this.roomLists[targetListID].querySelector('[data-room]');

      if (firstRoom && this.isMobile) {
        this.expandRoom(firstRoom);
      }

      var floorTl = gsap.timeline({
        defaults: {
          ease: 'power2.inOut',
          duration: 0.6
        },
        onComplete: function onComplete() {
          _this.isAnimating = false;

          _this.calcHeights();

          _this.rooms.forEach(function (room) {
            if (room !== firstRoom) room.classList.remove('is-active');
          });
        }
      });

      if (!this.isTablet) {
        floorTl.set(this.$element, {
          height: "".concat(this.$element.clientHeight, "px")
        });
      }

      floorTl.to(this.preview, {
        opacity: 0,
        onComplete: function onComplete() {
          if (targetData.image) {
            _this.updatePreview(targetData.image.url, targetData.image.alt);
          } else {
            _this.updatePreview('', '');
          }

          _this.hideOldPreview(true);
        }
      }, 'hide').to(this.summary, {
        opacity: 0,
        onComplete: function onComplete() {
          _this.updateSummary(targetData, true);
        }
      }, 'hide').to(this.roomLists, {
        opacity: 0,
        onComplete: function onComplete() {
          _this.roomLists.forEach(function (list) {
            if (list.dataset.listId === targetListID) {
              list.classList.add('is-active');
            } else {
              list.classList.remove('is-active');
            }
          });
        }
      }, 'hide').to(this.preview, {
        opacity: 1,
        onComplete: function onComplete() {
          _this.removeOldPreview();
        }
      }, 'show').to(this.summary, {
        opacity: 1
      }, 'show').to(this.roomLists, {
        opacity: 1
      }, 'show');

      if (!this.isTablet) {
        if (this.isMobile) {
          floorTl.to(this.$element, {
            height: 'auto',
            ease: 'power1.out'
          }, 'show');
        } else {
          floorTl.to(this.$element, {
            height: 'auto',
            ease: 'power1.out'
          });
        }
      }
    }
  }, {
    key: "roomSwitch",
    value: function roomSwitch(e) {
      var _this2 = this;

      var target = e.target;
      if (this.isAnimating) return;

      if (target.classList.contains('is-active')) {
        if (this.isMobile) {
          target.classList.remove('is-active');
          target.setAttribute('aria-expanded', false);
        }

        return;
      }

      this.isAnimating = true;
      this.rooms.forEach(function (room) {
        room.classList.remove('is-active');
        room.setAttribute('aria-expanded', false);
      });
      target.classList.add('is-active');
      target.setAttribute('aria-expanded', true);
      var roomTl = gsap.timeline({
        defaults: {
          ease: 'power2.inOut',
          duration: this.isMobile ? 0.1 : 0.6
        },
        onComplete: function onComplete() {
          _this2.isAnimating = false;
        }
      });

      if (!this.isTablet && !this.isMobile) {
        roomTl.set(this.$element, {
          height: "".concat(this.$element.clientHeight, "px")
        });
      }

      roomTl.to(this.summary, {
        opacity: 0,
        onStart: function onStart() {
          var imgEl = target.parentElement.querySelector('[data-image]');

          if (imgEl) {
            var newSrc = imgEl.dataset.src || imgEl.src;
            var newAlt = imgEl.alt;

            _this2.updatePreviewAnim(newSrc, newAlt);
          } else {
            _this2.updatePreviewAnim('', '');
          }
        },
        onComplete: function onComplete() {
          var textEl = target.parentElement.querySelector('[data-text]');

          if (textEl) {
            _this2.updateSummary(textEl);
          }
        }
      }, 'hide').to(this.summary, {
        opacity: 1
      }, 'show');

      if (!this.isTablet && !this.isMobile) {
        roomTl.to(this.$element, {
          height: 'auto',
          ease: 'power1.out'
        }, 'show');
      }
    }
  }, {
    key: "expandRoom",
    value: function expandRoom(target) {
      var _this3 = this;

      this.$element.classList.add('is-disabled');
      target.classList.add('is-active');
      target.setAttribute('aria-expanded', true);
      target.nextElementSibling.classList.add('no-anim');
      setTimeout(function () {
        target.nextElementSibling.classList.remove('no-anim');

        _this3.$element.classList.remove('is-disabled');
      }, 1500);
    }
  }, {
    key: "hideOldPreview",
    value: function hideOldPreview() {
      var immediately = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.isMobile) immediately = true;

      if (this.preview.childElementCount > 1) {
        var firstEl = this.preview.firstElementChild;
        gsap.to(firstEl, {
          autoAlpha: 0,
          duration: immediately ? 0.1 : 0.6
        });
      }
    }
  }, {
    key: "removeOldPreview",
    value: function removeOldPreview() {
      if (this.preview.childElementCount > 1) {
        var firstEl = this.preview.firstElementChild;
        this.preview.removeChild(firstEl);
      }
    }
  }, {
    key: "updatePreview",
    value: function updatePreview(src, alt) {
      if (src || src === '') {
        var img = document.createElement('img');
        img.className = 'media__image';
        img.src = src;
        img.alt = alt;
        this.preview.append(img);
      }
    }
  }, {
    key: "updatePreviewAnim",
    value: function updatePreviewAnim(src, alt) {
      var _this4 = this;

      if (src || src === '') {
        var img = document.createElement('img');
        img.style.opacity = 0;
        img.className = 'media__image';
        img.src = src;
        img.alt = alt;
        this.preview.append(img);
        gsap.to(img, {
          opacity: 1,
          duration: this.isMobile ? 0.2 : 1.2,
          ease: 'power1.out',
          onComplete: function onComplete() {
            _this4.removeOldPreview();
          }
        });
      }
    }
  }, {
    key: "updateSummary",
    value: function updateSummary(data) {
      var _this5 = this;

      var noanim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.isTablet && !noanim) {
        gsap.set(this.summary, {
          height: "".concat(this.summary.clientHeight, "px")
        });
      }

      if (!(data instanceof HTMLElement)) {
        var el = document.createElement('div');
        el.className = 'floor-pan__text';

        if (data.desc) {
          var desc = document.createElement('p');
          desc.className = 'floor-plan__desc';
          desc.innerHTML = data.desc;
          el.append(desc);
        }

        if (data.info) {
          var info = document.createElement('div');
          info.className = 'floor-plan__info';
          data.info.forEach(function (item) {
            var infoItem = document.createElement('div');
            infoItem.className = 'floor-plan__info-item';
            var infoTitle = document.createElement('div');
            infoTitle.className = 'floor-plan__info-title';
            infoTitle.innerHTML = item.title;
            var infoContent = document.createElement('p');
            infoContent.className = 'floor-plan__info-content';
            infoContent.innerHTML = item.text;
            infoItem.append(infoTitle);
            infoItem.append(infoContent);
            info.append(infoItem);
          });
          el.append(info);
        }

        this.summary.innerHTML = '';
        this.summary.append(el);
      } else {
        var _el = document.createElement('div');

        _el.className = 'floor-pan__text';
        _el.innerHTML = data.innerHTML;
        this.summary.innerHTML = '';
        this.summary.append(_el);
      }

      if (this.isTablet && !noanim) {
        setTimeout(function () {
          gsap.to(_this5.summary, {
            height: 'auto'
          });
        });
      }
    }
  }, {
    key: "setInitial",
    value: function setInitial() {
      this.floors.forEach(function (floor) {
        if (floor.classList.contains('is-active')) {
          floor.setAttribute('aria-expanded', true);
        } else {
          floor.setAttribute('aria-expanded', false);
        }
      });
      this.rooms.forEach(function (room) {
        if (room.classList.contains('is-active')) {
          room.setAttribute('aria-expanded', true);
        } else {
          room.setAttribute('aria-expanded', false);
        }
      });

      if (this.isMobile && this.rooms.length > 0) {
        this.expandRoom(this.rooms[0]);
      }
    }
  }, {
    key: "calcHeights",
    value: function calcHeights() {
      this.contents.forEach(function (content) {
        content.parentElement.style.setProperty('--content-height', "".concat(content.clientHeight, "px"));
      });
    }
  }, {
    key: "bind",
    value: function bind() {
      this.$on('resize-x', window, this.calcHeights);
    }
  }, {
    key: "disable",
    value: function disable() {
      this.isAnimating = true;
    }
  }, {
    key: "enable",
    value: function enable() {
      this.isAnimating = false;
    }
  }, {
    key: "isTablet",
    get: function get() {
      return window.matchMedia('(max-width: 1023px) and (min-width: 520px)').matches;
    }
  }, {
    key: "isMobile",
    get: function get() {
      return window.matchMedia('(max-width: 519px)').matches;
    }
  }]);

  return _class3;
}(Component), (_applyDecoratedDescriptor(_class3.prototype, "floorSwitch", [_dec2], Object.getOwnPropertyDescriptor(_class3.prototype, "floorSwitch"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "roomSwitch", [_dec3], Object.getOwnPropertyDescriptor(_class3.prototype, "roomSwitch"), _class3.prototype)), _class3)) || _class2);

export { _class as default };